module.exports = __webpack_public_path__ + "static/img/CheryMotorD.b2f8aa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/CheryMotorD.png
// module id = DX8j
// module chunks = 83